export const STORE_LISTING_URLS = {
  iOSLink:
    'https://apps.apple.com/app/apple-store/id598939260?pt=118164377&ct=AppPageRedirects&mt=8',
  androidLink:
    'https://play.google.com/store/apps/details?id=org.alephbeta.android&referrer=utm_source%3DApp%2520Page%26utm_medium%3Dlink%26utm_campaign%3DApp%2520Page'
};
